import React ,  {useEffect, useState}from 'react'
import { Button, Form ,TextArea,} from 'semantic-ui-react';
import { Field, useFormik } from 'formik';
import * as Yup from "yup";
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';
import {ADD_PUBLIC , PUBLIC_COMPLET } from '../../../../gql/publication';
//import Preview from '../../Publications/PreviewPublication./Preview';
//import "./Title.scss";
//import usePublic from '../../../hooks/usePublic';



export default function Promo (props) {
const  { publication , setShowModal } = props;
const [completPublic] = useMutation (PUBLIC_COMPLET);
const desk = publication.description


console.log(publication)

console.log (publication._id)



const formik = useFormik ({
  initialValues:initialValue(),


  validationSchema:Yup.object({
   
    whats:Yup.string().required() .matches(/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/, 'Whatsapp no valido')
    .min(10,"whatsapp muy corto")
    .max(10, "whatsapp muy largo"), 

  }),


  onSubmit: async (formv) => {try
    { const formData= formv;
      console.log(formv);

       await completPublic({
        variables:{
          input:{
            idPublication:publication._id,
            whats:formData.whats,
            
          },
          },}
      );
      toast.success (" Whatsapp Establesido 😁 ");

      setTimeout(() =>  setShowModal (false),3000);


      
}    catch (error) {
      toast.error(error.message);
      console.log (error)
      console.log (formv)
    }
  },

 });





  return (
    
        <Form  onSubmit = {formik.handleSubmit} className= "mosset">
        <h2>
        Es importante  colocar  un numero valido de WhastApp para que puedan contactarte ❗ 
                                                
        </h2>
        <h2>     📞  </h2>
          
   <h2> Whatsapp </h2>
         <Form.Input type= "Text" placeholder = {publication.whats}
         name= "whats"  
         value = {formik.values.whats}
        onChange = {formik.handleChange}
        error={formik.errors.whats && true}

      />

      <Button type= "submit" className=' btn-submit'>  * Publicar * </Button> 

        </Form>
    
  )
}
function initialValue() {
  return  {
    "idPublication": "",
    "whats": "",  
  };
};
